module.exports = __webpack_public_path__ + "img/video_shere(10).7928ba91.png";